import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import type { ApiErrorDetails } from '@/lib/getApiErrorMessage';

interface ApiErrorSummaryProps {
  error: ApiErrorDetails | null;
}

export function ApiErrorSummary({ error }: ApiErrorSummaryProps) {
  if (!error) return null;

  const hasFieldErrors =
    error.fieldErrors && Object.keys(error.fieldErrors).length > 0;

  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{error.message}</AlertTitle>
      {hasFieldErrors && (
        <AlertDescription>
          <ul className="mt-1.5 list-disc pl-4 space-y-0.5">
            {Object.entries(error.fieldErrors!).map(([field, messages]) =>
              messages.map((msg, i) => (
                <li key={`${field}-${i}`}>{msg}</li>
              ))
            )}
          </ul>
        </AlertDescription>
      )}
    </Alert>
  );
}
